// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__-4CVR","disabled":"FileBtn_disabled__3QnwB","warn":"FileBtn_warn__1klmi","fade":"FileBtn_fade__1i6IO"};